import { render } from "./Index.vue?vue&type=template&id=452bfe15"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/ItemLocations/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "452bfe15"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('452bfe15', __exports__)) {
    console.log('reload')
    api.reload('452bfe15', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=452bfe15", () => {
    console.log('re-render')
    api.rerender('452bfe15', render)
  })

}


export default __exports__